module.exports = __webpack_public_path__ + "static/media/logo_armory.d40870bf.png";